let elements = {
  blockCheck: true,
  fontFamily: 'Linotype',
  fontSize: '45px',
  mainImage: {
    imagePath: 'games/page030_game2/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  withoutCheck: false,
  columns: 4,
  audio: {
    negative: 'games/page030_game2/audio/false.mp3',
    positive: 'games/page030_game2/audio/true.mp3',
    click: 'games/page030_game2/audio/click.mp3',
  },
  imageHighlight: true,
  curtain: 'transparent',
  curtainImage: {
    src: 'games/page030_game2/img/des.webp',
  },
  width: 346,
  bcgImg: 'games/page030_game2/img/desBcg.webp',
  height: 272,
  // goodAudio: 'games/page030_game2/audio/z2c2.mp3',
  colors: ['#f7a82b', '#ffff00', '#ed6c9e', '#ff0000', '#00a8ec', '#00b034'],
  pick: 6,
  fields: [
    {
      id: 0,
      image: {
        src: 'games/page030_game2/img/29.png',
      },
      audioSrc: 'games/page030_game2/audio/29.mp3',
      pair: {
        id: 0,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'car',
        audioSrc: 'games/page030_game2/audio/29.mp3',
      },
    },
    {
      id: 1,
      image: {
        src: 'games/page030_game2/img/30.png',
      },
      audioSrc: 'games/page030_game2/audio/30.mp3',
      pair: {
        id: 1,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'doll',
        audioSrc: 'games/page030_game2/audio/30.mp3',
      },
    },
    {
      id: 2,
      image: {
        src: 'games/page030_game2/img/31.png',
      },
      audioSrc: 'games/page030_game2/audio/31.mp3',
      pair: {
        id: 2,

        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'ball',
        audioSrc: 'games/page030_game2/audio/31.mp3',
      },
    },
    {
      id: 3,
      image: {
        src: 'games/page030_game2/img/32.png',
      },
      audioSrc: 'games/page030_game2/audio/32.mp3',
      pair: {
        id: 3,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'robot',
        audioSrc: 'games/page030_game2/audio/32.mp3',
      },
    },
    {
      id: 4,
      image: {
        src: 'games/page030_game2/img/33.png',
      },
      audioSrc: 'games/page030_game2/audio/33.mp3',
      pair: {
        id: 4,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'one',
        audioSrc: 'games/page030_game2/audio/33.mp3',
      },
    },
    {
      id: 5,
      image: {
        src: 'games/page030_game2/img/34.png',
      },
      audioSrc: 'games/page030_game2/audio/34.mp3',
      pair: {
        id: 5,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'two',
        audioSrc: 'games/page030_game2/audio/34.mp3',
      },
    },
    {
      id: 6,
      audioSrc: 'games/page030_game2/audio/35.mp3',
      image: {
        src: 'games/page030_game2/img/35.png',
      },
      pair: {
        id: 6,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'three',
        audioSrc: 'games/page030_game2/audio/35.mp3',
      },
    },
    {
      id: 7,
      audioSrc: 'games/page030_game2/audio/36.mp3',
      image: {
        src: 'games/page030_game2/img/36.png',
      },
      pair: {
        id: 7,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'sing',
        audioSrc: 'games/page030_game2/audio/36.mp3',
      },
    },
    {
      id: 8,
      audioSrc: 'games/page030_game2/audio/37.mp3',
      image: {
        src: 'games/page030_game2/img/37.png',
      },
      pair: {
        id: 8,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'catch',
        audioSrc: 'games/page030_game2/audio/37.mp3',
      },
    },
    {
      id: 9,
      audioSrc: 'games/page030_game2/audio/38.mp3',
      image: {
        src: 'games/page030_game2/img/38.png',
      },
      pair: {
        id: 9,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'clap',
        audioSrc: 'games/page030_game2/audio/38.mp3',
      },
    },
    {
      audioSrc: 'games/page030_game2/audio/39.mp3',
      id: 10,
      image: {
        src: 'games/page030_game2/img/39.png',
      },
      pair: {
        id: 10,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'dance',
        audioSrc: 'games/page030_game2/audio/39.mp3',
      },
    },
    {
      audioSrc: 'games/page030_game2/audio/40.mp3',
      id: 11,
      image: {
        src: 'games/page030_game2/img/40.png',
      },
      pair: {
        id: 11,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'run',
        audioSrc: 'games/page030_game2/audio/40.mp3',
      },
    },
    {
      audioSrc: 'games/page030_game2/audio/41.mp3',
      id: 12,
      image: {
        src: 'games/page030_game2/img/41.png',
      },
      pair: {
        id: 12,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'paint',
        audioSrc: 'games/page030_game2/audio/41.mp3',
      },
    },
    {
      audioSrc: 'games/page030_game2/audio/42.mp3',
      id: 13,
      image: {
        src: 'games/page030_game2/img/42.png',
      },
      pair: {
        id: 13,
        cssStyle: {
          fontFamily: 'Linotype',
          fontSize: '45px',
        },
        text: 'jump',
        audioSrc: 'games/page030_game2/audio/42.mp3',
      },
    },
  ],
  // mbAudioItemData: [
  // ],
};
export default elements;
